import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap';
import { CommercialRoutingModule } from './commercial-routing.module';
import { AgmCoreModule } from '@agm/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { CommercialComponent } from './commercial.component';
import { HomeMainComponent } from './home-main/home-main.component';
// import { GetStartedComponent } from './get-started/get-started.component';
// import { GetstartedComponent } from './get-started/getstarted/getstarted.component';
// import { HeaderComponent } from './get-started/header/header.component';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { CommercialQuestionnaireComponent } from './questionnaire/commercial-questionnaire/commercial-questionnaire.component';
import { CommercialDirective } from './questionnaire/commercial.directive';
import { Cq1Component } from './questionnaire/commercial-questionnaire/cq1/cq1.component';
import { Cq2Component } from './questionnaire/commercial-questionnaire/cq2/cq2.component';
import { Cq3Component } from './questionnaire/commercial-questionnaire/cq3/cq3.component';
import { Cq4Component } from './questionnaire/commercial-questionnaire/cq4/cq4.component';
import { Cq5Component } from './questionnaire/commercial-questionnaire/cq5/cq5.component';
import { Cq6Component } from './questionnaire/commercial-questionnaire/cq6/cq6.component';
import { AboutComponent } from './home-main/about/about.component';
import { HeaderComponent } from './home-main/header/header.component';
import { FooterComponent } from './home-main/footer/footer.component';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { PreCongratsComponent } from './enrollment/pre-congrats/pre-congrats.component';
import { CommonHeaderComponent } from './common-header/common-header.component';
import { CongratsComponent } from './enrollment/congrats/congrats.component';
import { GetStartedModule } from './get-started/get-started.module';
import { Cq7Component } from './questionnaire/commercial-questionnaire/cq7/cq7.component';
import { Cq8Component } from './questionnaire/commercial-questionnaire/cq8/cq8.component';
import { Cq9Component } from './questionnaire/commercial-questionnaire/cq9/cq9.component';
import { Cq10Component } from './questionnaire/commercial-questionnaire/cq10/cq10.component';
import { Cq11Component } from './questionnaire/commercial-questionnaire/cq11/cq11.component';
import { Cq12Component } from './questionnaire/commercial-questionnaire/cq12/cq12.component';
import { Cq13Component } from './questionnaire/commercial-questionnaire/cq13/cq13.component';
import { Cq14Component } from './questionnaire/commercial-questionnaire/cq14/cq14.component';
import { HgCommonModule } from '../hg-common/hg-common.module';
import { MyDatePickerModule } from 'mydatepicker';
import { Cq15Component } from './questionnaire/commercial-questionnaire/cq15/cq15.component';
import { Cq16Component } from './questionnaire/commercial-questionnaire/cq16/cq16.component';
import { Cq17Component } from './questionnaire/commercial-questionnaire/cq17/cq17.component';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { ConfirmEnrollmentComponent } from './enrollment/confirm-enrollment/confirm-enrollment.component';
import { Cq18Component } from './questionnaire/commercial-questionnaire/cq18/cq18.component';
import { Cq19Component } from './questionnaire/commercial-questionnaire/cq19/cq19.component';
import { Cq20Component } from './questionnaire/commercial-questionnaire/cq20/cq20.component';
import { Cq21Component } from './questionnaire/commercial-questionnaire/cq21/cq21.component';
import { Cq22Component } from './questionnaire/commercial-questionnaire/cq22/cq22.component';
import { Cq23Component } from './questionnaire/commercial-questionnaire/cq23/cq23.component';
import { Cq24Component } from './questionnaire/commercial-questionnaire/cq24/cq24.component';
import { Cq25Component } from './questionnaire/commercial-questionnaire/cq25/cq25.component';
import { AlphaNumericDirective } from './questionnaire/commercial-questionnaire/alphaNumeric.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { SqftDirective } from './questionnaire/commercial-questionnaire/sqft-directive';
import { ClickOutside } from './click-outside.directive';
import { PhoneNumberValidDirective } from './phone-number-valid.directive';

@NgModule({
  imports: [
    CommonModule,
    CommercialRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollToModule,
    HgCommonModule,
    FileUploadModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDGLXj7CWMeCf-OcQFz3lUTglkuDDYg_6c',
      libraries: ['places'],
    }),
    GooglePlaceModule,
    GetStartedModule,
    MyDatePickerModule,
    NgSelectModule,
    TypeaheadModule.forRoot(),
  ],
  declarations: [
    CommercialComponent,
    HomeMainComponent,
    EnrollmentComponent,
    QuestionnaireComponent,
    CommercialQuestionnaireComponent,
    CommercialDirective,
    AboutComponent,
    HeaderComponent,
    FooterComponent,
    PreCongratsComponent,
    CommonHeaderComponent,
    CongratsComponent,
    Cq1Component,
    Cq2Component,
    Cq3Component,
    Cq4Component,
    Cq5Component,
    Cq6Component,
    Cq7Component,
    Cq8Component,
    Cq9Component,
    Cq10Component,
    Cq11Component,
    Cq12Component,
    Cq13Component,
    Cq14Component,
    Cq15Component,
    Cq16Component,
    Cq17Component,
    Cq18Component,
    Cq19Component,
    Cq20Component,
    Cq21Component,
    Cq22Component,
    Cq23Component,
    Cq24Component,
    Cq25Component,
    ConfirmEnrollmentComponent,
    AlphaNumericDirective,
    SqftDirective,
    ClickOutside,
    PhoneNumberValidDirective,
  ],
  entryComponents: [
    Cq1Component,
    Cq2Component,
    Cq3Component,
    Cq4Component,
    Cq5Component,
    Cq6Component,
    Cq7Component,
    Cq8Component,
    Cq9Component,
    Cq10Component,
    Cq11Component,
    Cq12Component,
    Cq13Component,
    Cq14Component,
    Cq15Component,
    Cq16Component,
    Cq17Component,
    Cq18Component,
    Cq19Component,
    Cq20Component,
    Cq21Component,
    Cq22Component,
    Cq23Component,
    Cq24Component,
  ],
  exports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class CommercialModule {}
